import type { ExtractData } from "./types/types";
import {
  datetimeFormatter,
  hourFormatter,
  kmFormatter,
  numberFormatter,
} from "../../shared/utils";

type ExtractSummaryProps = {
  summary: Pick<
    ExtractData,
    | "assetName"
    | "initialDatetimeUtc"
    | "finalDatetimeUtc"
    | "distanceInKm"
    | "engineHours"
    | "usageFactor"
  >;
};

export function ExtractSummary({ summary }: ExtractSummaryProps) {
  const info = [
    { label: "Veículo", value: summary.assetName, icon: "rioglyph-truck" },
    {
      label: "Início",
      value: datetimeFormatter.format(new Date(summary.initialDatetimeUtc)),
      icon: "rioglyph-calendar",
    },
    {
      label: "Fim",
      value: datetimeFormatter.format(new Date(summary.finalDatetimeUtc)),
      icon: "rioglyph-calendar",
    },
    {
      label: "Tempo de Motor",
      value: hourFormatter.format(summary.engineHours),
      icon: "rioglyph-engine",
    },
    {
      label: "Distância",
      value: kmFormatter.format(summary.distanceInKm),
      icon: "rioglyph-road",
    },
    {
      label: "Fator",
      value: numberFormatter.format(summary.usageFactor),
      icon: "rioglyph-line-chart",
    },
  ];

  return (
    <div className="display-grid grid-cols-1 cq-300:grid-cols-2 cq-500:grid-cols-3 cq-600:grid-cols-6 gap-20">
      {info.map(({ label, value, icon }) => (
        <div key={label} className="display-grid gap-5">
          <span className="text-color-dark">{label}</span>
          <span style={{minWidth: 60, overflowWrap: "break-word"}}>
            <span
              className={`rioglyph ${icon} rioglyph-align-baseline text-size-20 text-color-gray`}
            />{" "}
            {value}
          </span>
        </div>
      ))}
    </div>
  );
}
